

import React from 'react';

const ImageUploadDropzone = ({ handlerFunction }) => {

      const acceptedFileTypes = [
        'image/jpeg',
        'image/png',
        'image/gif',
        'application/pdf'
    ];

       const handleFile = (file) => {
        if (!file) {
            return;
        }
        if (!acceptedFileTypes.includes(file.type)) {
            alert('Only JPG, PNG, GIF and PDF files are allowed.');
            return;
        }
        handlerFunction(file);
    };

    return (
        <div
            className="image-upload-dropzone"
            onDragEnter={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
            onDragOver={(e) => {
                e.preventDefault();
                e.stopPropagation();

                e.dataTransfer.dropEffect = 'copy';
            }}
            onDrop={(e) => {
                e.preventDefault();
                e.stopPropagation();

                const file = e.dataTransfer.files[0];

                handleFile(file);
            }}
        >
            <p className="image-upload-dropzone-text">
                Drag & drop an image here or choose a file below
            </p>

            <input
                accept="image/jpeg, image/png, image/gif, application/pdf"
                type="file"
                onChange={(e) => {
                    handleFile(e.target.files[0]);
                }}
            />
        </div>
    );
};

export default ImageUploadDropzone;


// WEBPACK FOOTER //
// ./src/views/report/image_upload_dropzone.js